export default function __(string) {
    if ( typeof(window.translations) !== 'undefined' && typeof window.translations[ string ] !== 'undefined' ) {
        return window.translations[ string ];
    }

    return string;
}